import Vue from 'vue'
import Vuex from 'vuex'
import BackendService from '../services/requests/backendService'
import FrontendConfigService from '../services/configs/frontendConfigService'
import AuthService from '@/services/authService'

Vue.use(Vuex)

const globalStore = new Vuex.Store({

	state: {
		contexto_selecionado:{},
		settings:{},
		notifications:[],
		loading: false
	},
	mutations: {
		setLoading(state, value){ state.loading = value },
		setContexto(state, value){ state.contexto_selecionado = value },
		setSettings(state, value){ state.settings = value },
		setNotifications(state, value){ 
			state.notifications = value 
		}
	},
	getters:{
		getContexto(state){
			return state.contexto_selecionado
		},
		getNotifications(state){
			return state.notifications
		},
		isAdmin(){
			let logado = AuthService.obterUsuarioAutenticado()
			return AuthService.hasPerms(['DBA_S','AGENDA_SAUDE_S']) || logado.is_superuser || logado.is_staff
		},
		isAuth(){
			let logado = AuthService.obterUsuarioAutenticado()
			return logado.username && logado.email
		},
		getMonthsList(){
			return [
				{ value: 1 , text: 'Janeiro'},
				{ value: 2 , text: 'Fevereiro'},
				{ value: 3 , text: 'Março'},
				{ value: 4 , text: 'Abril'},
				{ value: 5 , text: 'Maio'},
				{ value: 6 , text: 'Junho'},
				{ value: 7 , text: 'Julho'},
				{ value: 8 , text: 'Agosto'},
				{ value: 9 , text: 'Setembro'},
				{ value: 10, text: 'Outubro'},
				{ value: 11, text: 'Novembro'},
				{ value: 12, text: 'Dezembro'},
			]
		}
	},
	actions:{
		tryError: async(context, error)=>{
			let err = FrontendConfigService.tryNotificationErrors(error)
			context.commit('setNotifications', [{'tag':err.tag, 'message': err.message}])
		},
		request_settings: async (context)=>{
			context.commit('setLoading', true); 
			const req = new BackendService()
			return await req.get_settings()
			.then( response => { 
				context.commit('setSettings', response.data); 
			}).catch( error => { 
				console.error(error); 
				context.commit('setSettings', []) 
				context.dispatch('tryError', error) 
			}).finally( () => { 
				context.commit('setLoading', false); 
			})
		},
		update_settings: async (context, {pk, data})=>{
			const req = new BackendService()
			context.commit('setLoading', true); 
			return await req.patch_settings(pk, data)
			.then( response => { 
				context.commit('setSettings', response.data); 
				context.commit('setNotifications', [{'tag':'success', 'message': 'Salvo com sucesso'}])
				context.dispatch('request_settings')
			}).catch( error => { 
				console.error(error); 
				context.commit('setSettings', []) 
				context.dispatch('tryError', error) 
				context.commit('setNotifications', [{'tag':'error', 'message': 'Falha ao salvar configurações'}])
			}).finally( () => { 
				context.commit('setLoading', false); 
			})
		},
	}
})
export default globalStore
